import { ONE_MINUTE_MS } from '@/shared/constants/app/time.constant';

/**
 * XCOST 루프백 리스너가 콜백을 받은 뒤 302 로 보내는 완료 화면의 결과 코드.
 * 예) {WEB}/desktop/complete?result=success
 * 키·값이 곧 XCOST(C#)와의 계약이다. 화면은 이 값으로 고정 문구만 고른다 — 다른 값은 invalid.
 */
export const DESKTOP_COMPLETE_QUERY = 'result';

export const DESKTOP_COMPLETE_RESULT = {
  SUCCESS: 'success',
  DENIED: 'denied',
  INVALID: 'invalid',
} as const;

export type DesktopCompleteResult =
  (typeof DESKTOP_COMPLETE_RESULT)[keyof typeof DESKTOP_COMPLETE_RESULT];

export function parseCompleteResult(raw: string | null): DesktopCompleteResult {
  return raw === DESKTOP_COMPLETE_RESULT.SUCCESS || raw === DESKTOP_COMPLETE_RESULT.DENIED
    ? raw
    : DESKTOP_COMPLETE_RESULT.INVALID;
}

/**
 * XCOST 가 콜백을 기다리는 시간(가이드 ②). 리스너는 동의 화면보다 먼저 열리므로,
 * 동의 화면을 연 뒤 이만큼 지났으면 리스너는 이미 닫혀 있다.
 */
const LOOPBACK_WAIT_MINUTES = 5;
export const DESKTOP_LOOPBACK_WAIT_MS = LOOPBACK_WAIT_MINUTES * ONE_MINUTE_MS;
